import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index";
import { createBootstrap } from "bootstrap-vue-next"; 
import { QuillEditor } from "@vueup/vue-quill";
import Toast from "vue-toastification";
import VueDatePicker from '@vuepic/vue-datepicker';  
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';

import "@vueup/vue-quill/dist/vue-quill.snow.css";
import "@vueup/vue-quill/dist/vue-quill.bubble.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./assets/css/remixicon.css";
import "./assets/css/sidebar-menu.css";
import "./assets/css/simplebar.css";
import "./assets/scss/style.css";
import "vue-toastification/dist/index.css";
import '@vuepic/vue-datepicker/dist/main.css';

const options = {
  // no typing needed
  position: "top-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
};

const app = createApp(App).use(router);
app.use(createBootstrap());
app.use(Toast, options);
app.component('VueDatePicker', VueDatePicker); 
app.component("QuillEditor", QuillEditor);

app.mount("#app");
